import { Link } from 'react-router-dom';
import { cn } from '../../../../shared';
import { COLORS } from '../taActionBoard/format';
import { SECTIONS, type SectionId } from './sections';

/**
 * The tool's own navigation, like the TA Action Boards: a FINN-black rail inside the page, next to
 * People Space's sidebar, so the Talent Community reads as one tool. Sections as in Anna's mockup
 * v0.5; each is a link to its own URL.
 */
export function ToolSidebar({ current }: { current: SectionId }) {
  return (
    <aside className="w-56 shrink-0 border-r border-white/10 bg-[#1A1A1A] p-3">
      <p className="px-2 pb-3 pt-1 text-sm font-semibold text-white">Talent Community</p>
      <nav aria-label="Talent Community sections" className="space-y-4">
        {SECTIONS.map((group) => (
          <div key={group.heading ?? 'main'} className="space-y-1">
            {group.heading && (
              <p className="px-2 pt-2 text-xs font-semibold uppercase tracking-wide text-white/40">{group.heading}</p>
            )}
            {group.items.map(([id, label]) => {
              const active = current === id;
              return (
                <Link
                  key={id}
                  to={`/talent-pool/${id}`}
                  aria-current={active ? 'page' : undefined}
                  className={cn(
                    'block rounded-lg px-3 py-2 text-sm transition-colors',
                    active ? 'font-semibold' : 'text-white/70 hover:bg-white/10',
                  )}
                  style={
                    active
                      ? {
                          backgroundColor: COLORS.blueBg,
                          color: COLORS.blueText,
                        }
                      : undefined
                  }
                >
                  {label}
                </Link>
              );
            })}
          </div>
        ))}
      </nav>
    </aside>
  );
}
